/**
 * Beschriftungen und Regel der privaten Assistenz (PO 21.09.2026).
 *
 * Gegenstück zu `apps/api/src/data/privateAssistenz.ts` — die beiden
 * Rollen-Strings SIND der Speicherwert und müssen dort zeichengleich stehen.
 * Die Begründung des Datenmodells steht drüben; hier liegt nur, was die
 * Oberfläche zum Anzeigen braucht.
 */

/** Was die Assistenz FÜR die Leitungsperson ist — der Speicherwert. */
export const ASSISTENZ_ROLLE = "Private Assistenz";

/** Was die Leitungsperson für die Assistenz ist (`reverseRelationType`). */
export const ASSISTENZ_GEGENROLLE = "Assistierte Person";

/**
 * „Private Assistenz von Meier, Anna" — die Beschriftung in der Firmenakte.
 *
 * Ohne bekannten Namen bleibt es bei der Rolle allein. Der Name wird NIE
 * gespeichert, sondern immer hier zusammengesetzt: Im PROD-Bestand steht eine
 * Zeile mit der Funktion „Assistenz-Gerd-Boltersdorf" — genau das soll nicht
 * wieder entstehen, denn sie veraltet bei der ersten Umbenennung.
 */
export const assistenzLabel = (fuerName?: string | null): string => {
  const name = (fuerName ?? "").trim();
  return name ? `${ASSISTENZ_ROLLE} von ${name}` : ASSISTENZ_ROLLE;
};
